export default [
    {
        path: '/dajin',
        name: 'dajin',
        meta: {
            title: '打金',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
            hasBottom: true
        },
        component: () => import('./Games'),
    },
    {
        path: '/gamesSearch',
        name: 'gamesSearch',
        meta: {
            title: '游戏搜索',
            noheader: true,
            unPullRefresh: true,
            pl0: true,
            pr0: true,
  
        },
        component: () => import('./GamesSearch'),
    }
]